import { Box, BoxProps, Button, HStack } from "@chakra-ui/react";
import React, { FC, useLayoutEffect, useMemo } from "react";
import { TLeadAttributionPerson } from "types/account-lead-attribution-analyticis.type";
import { LEADS_ALL_ROUTE } from "constants/routes";
import { getUserFullName } from "utils/account-user.utils";

interface IProps {
  person: TLeadAttributionPerson;
  style?: BoxProps["style"];
  onLoad?: () => void;
}

export const LeadAttributionPeopleListItem: FC<IProps> = ({
  person,
  onLoad,
  style,
}) => {
  useLayoutEffect(() => {
    onLoad?.();
  }, [onLoad, person.id]);

  const href = useMemo(() => {
    return `${LEADS_ALL_ROUTE}?personIds=${person.id}`;
  }, [person]);

  const name = useMemo(() => {
    return (
      getUserFullName(person?.firstName, person?.lastName, person?.fullName) ||
      "Unknown name"
    );
  }, [person]);

  return (
    <Box style={style} width={"100%"}>
      <Box
        p={4}
        mt={2}
        border={"1px"}
        borderRadius={"lg"}
        borderColor={"leadpro.200"}
      >
        <HStack justifyContent={"space-between"} alignItems={"center"}>
          <Box>
            <Box>{name}</Box>
            <Box fontSize={"xs"} color={"gray.500"}>
              {person.email}
            </Box>
          </Box>
          <Button
            variant={"link"}
            as={"a"}
            fontWeight={500}
            href={href}
            target={"_blank"}
            color={"leadpro.800"}
          >
            View Lead
          </Button>
        </HStack>
      </Box>
    </Box>
  );
};
